import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseService } from 'tms-web-shared';
import { MachineJobSchedule } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class MachineJobScheduleService extends TmsWebBaseService {
  constructor() {
    super('MachineJobSchedule');
  }

  getForMachine(machineId: string): Observable<MachineJobSchedule[]> {
    return this.httpService.get<MachineJobSchedule[]>(`${this.apiUrl}/Machine/${machineId}`);
  }

  addJob(machineId: string, jobId: string): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/AddJob/${machineId}/${jobId}`, {});
  }

  removeJob(machineId: string, jobId: string): Observable<any> {
    return this.httpService.delete(`${this.apiUrl}/${machineId}/${jobId}`);
  }

  moveUp(machineId: string, jobId: string): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/MoveUp/${machineId}/${jobId}`, {});
  }

  moveDown(machineId: string, jobId: string): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/MoveDown/${machineId}/${jobId}`, {});
  }
}
